export class Usuario {
    nome: string;
    senha: string;
}



// WEBPACK FOOTER //
// ./src/app/_classes/usuario.ts